module.exports = __webpack_public_path__ + "static/media/medicacao.4c56112a.jpg";